import { render, staticRenderFns } from "./PricingSettingsTab.vue?vue&type=template&id=823c5e92&scoped=true"
import script from "./PricingSettingsTab.vue?vue&type=script&lang=js"
export * from "./PricingSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./PricingSettingsTab.vue?vue&type=style&index=0&id=823c5e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823c5e92",
  null
  
)

export default component.exports